import { Component, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [RouterLink, CommonModule],
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent {
  private router = inject(Router);

  isModulesMenuOpen = false;
  isIndustriesMenuOpen = false;

  openModulesMenu() {
    this.isModulesMenuOpen = true;
    this.isIndustriesMenuOpen = false;
    this.updateBodyScroll();
  }
  
  toggleModulesMenu() {
    this.isModulesMenuOpen = !this.isModulesMenuOpen;
    if (this.isModulesMenuOpen) {
      this.isIndustriesMenuOpen = false;
    }
    this.updateBodyScroll();
  }

  closeModulesMenu() {
    this.isModulesMenuOpen = false;
    this.updateBodyScroll();
  }

  openIndustriesMenu() {
    this.isIndustriesMenuOpen = true;
    this.isModulesMenuOpen = false;
    this.updateBodyScroll();
  }

  toggleIndustriesMenu() {
    this.isIndustriesMenuOpen = !this.isIndustriesMenuOpen;
    if (this.isIndustriesMenuOpen) {
      this.isModulesMenuOpen = false;
    }
    this.updateBodyScroll();
  }

  closeIndustriesMenu() {
    this.isIndustriesMenuOpen = false;
    this.updateBodyScroll();
  }

  closeAll() {
    this.isModulesMenuOpen = false;
    this.isIndustriesMenuOpen = false;
    this.updateBodyScroll();
  }

  private updateBodyScroll() {
    document.body.style.overflow = (this.isModulesMenuOpen || this.isIndustriesMenuOpen) ? 'hidden' : '';
  }

  navigateAndClose(path: string) {
    this.closeAll();
    this.router.navigate([path]);
  }
}
